import sanitizeHTML from 'sanitize-html';

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'u',
  's',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'li',
  'a',
  'blockquote',
  'span',
];

const ALLOWED_ATTRIBUTES: sanitizeHTML.IOptions['allowedAttributes'] = {
  a: ['href', 'target', 'rel'],
  li: ['data-list', 'class'],
  ol: ['class'],
  ul: ['class'],
  span: ['class'],
  p: ['class'],
};

export const sanitizeRichHtml = (html: string): string =>
  sanitizeHTML(html, {
    allowedTags: ALLOWED_TAGS,
    allowedAttributes: ALLOWED_ATTRIBUTES,
    allowedSchemes: ['http', 'https', 'mailto'],
    transformTags: {
      a: (tagName, attribs) => {
        const href = attribs.href;
        const normalizedHref = href && !/^(https?:|mailto:)/i.test(href) ? `https://${href}` : href;
        return {
          tagName,
          attribs: {
            ...attribs,
            href: normalizedHref,
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        };
      },
    },
  });
